// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* One 9 s loop, as on the Manage apps page in Wix: the arrow at the end of our app's row (0-24 %), the panel on the
   right and its "Delete app" (24-47 %), the confirm dialog (47-72 %), then the app row disappears (72-96 %).
   The step list highlights the step the animation is on. */

.wu-guide-wrap {
  margin: 0 0 18px 0;
}

.wu-guide {
  display: block;
  width: 100%;
  height: auto;
}

.wu-guide text {
  font-family: inherit;
}

.wu-title {
  font-size: 13px;
  font-weight: 600;
  fill: #111827;
}

.wu-name {
  font-size: 11.5px;
  font-weight: 600;
  fill: #111827;
}

.wu-icon-letter {
  font-size: 12px;
  font-weight: 700;
  fill: #fff;
}

.wu-del {
  font-size: 11.5px;
  font-weight: 500;
  fill: #111827;
}

.wu-confirm-label {
  font-size: 11.5px;
  font-weight: 600;
  fill: #fff;
}

.wu-cursor,
.wu-panel,
.wu-dialog,
.wu-ultimo,
.wu-arrow-bg,
.wu-del-hover,
.wu-confirm,
.wu-ring,
.wu-step-2,
.wu-step-3 {
  animation-duration: 9s;
  animation-iteration-count: infinite;
}

.wu-cursor {
  animation-name: wu-cursor;
  animation-timing-function: ease-in-out;
  opacity: 0;
}

@keyframes wu-cursor {
  0% { transform: translate(150px, 172px) scale(1); opacity: 0; }
  5% { transform: translate(150px, 172px) scale(1); opacity: 1; }
  19% { transform: translate(353px, 67px) scale(1); }
  21% { transform: translate(353px, 67px) scale(0.82); }
  24% { transform: translate(353px, 67px) scale(1); }
  29% { transform: translate(353px, 67px) scale(1); }
  40% { transform: translate(286px, 160px) scale(1); }
  42% { transform: translate(286px, 160px) scale(0.82); }
  45% { transform: translate(286px, 160px) scale(1); }
  60% { transform: translate(239px, 122px) scale(1); }
  62% { transform: translate(239px, 122px) scale(0.82); }
  65% { transform: translate(239px, 122px) scale(1); opacity: 1; }
  72% { transform: translate(239px, 122px) scale(1); opacity: 0; }
  100% { transform: translate(150px, 172px) scale(1); opacity: 0; }
}

.wu-arrow-bg {
  animation-name: wu-arrow-bg;
  opacity: 0;
}

@keyframes wu-arrow-bg {
  0%, 15% { opacity: 0; }
  18%, 26% { opacity: 1; }
  29%, 100% { opacity: 0; }
}

.wu-panel {
  animation-name: wu-panel;
  animation-timing-function: ease-out;
  transform: translateX(160px);
}

@keyframes wu-panel {
  0%, 22% { transform: translateX(160px); }
  27%, 70% { transform: translateX(0); }
  76%, 100% { transform: translateX(160px); }
}

.wu-del-hover {
  animation-name: wu-del-hover;
  opacity: 0;
}

@keyframes wu-del-hover {
  0%, 36% { opacity: 0; }
  38%, 47% { opacity: 1; }
  50%, 100% { opacity: 0; }
}

.wu-dialog {
  animation-name: wu-dialog;
  opacity: 0;
}

@keyframes wu-dialog {
  0%, 46% { opacity: 0; }
  50%, 68% { opacity: 1; }
  72%, 100% { opacity: 0; }
}

.wu-confirm {
  animation-name: wu-confirm;
  fill: #dc2626;
}

@keyframes wu-confirm {
  0%, 61% { fill: #dc2626; }
  62%, 66% { fill: #991b1b; }
  68%, 100% { fill: #dc2626; }
}

.wu-ultimo {
  animation-name: wu-ultimo;
}

@keyframes wu-ultimo {
  0%, 76% { opacity: 1; }
  82%, 92% { opacity: 0; }
  98%, 100% { opacity: 1; }
}

.wu-ring {
  fill: none;
  stroke: #5616ea;
  stroke-width: 2;
  opacity: 0;
  transform-box: fill-box;
  transform-origin: center;
}

.wu-ring-1 { animation-name: wu-ring-1; }
.wu-ring-2 { animation-name: wu-ring-2; }
.wu-ring-3 { animation-name: wu-ring-3; }

@keyframes wu-ring-1 {
  0%, 20% { opacity: 0; transform: scale(0.4); }
  21% { opacity: 0.9; transform: scale(0.4); }
  29%, 100% { opacity: 0; transform: scale(1.5); }
}

@keyframes wu-ring-2 {
  0%, 41% { opacity: 0; transform: scale(0.4); }
  42% { opacity: 0.9; transform: scale(0.4); }
  50%, 100% { opacity: 0; transform: scale(1.5); }
}

@keyframes wu-ring-3 {
  0%, 61% { opacity: 0; transform: scale(0.4); }
  62% { opacity: 0.9; transform: scale(0.4); }
  70%, 100% { opacity: 0; transform: scale(1.5); }
}

.wu-steps {
  list-style: none;
  margin: 12px 0 0 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.wu-step {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 6px 8px;
  border-radius: 8px;
  font-size: 13.5px;
  line-height: 1.45;
  color: #374151;
}

.wu-step-num {
  flex: 0 0 auto;
  width: 20px;
  height: 20px;
  margin-top: 0.5px;
  border-radius: 50%;
  background: #f3eaff;
  color: #5616ea;
  font-size: 12px;
  font-weight: 600;
  line-height: 20px;
  text-align: center;
}

.wu-arrow-chip {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  margin: 0 1px;
  vertical-align: -4px;
  border: 1px solid #d1d5db;
  border-radius: 5px;
  background: #fff;
}

.wu-step-num-done {
  background: #dcfce7;
  color: #15803d;
}

/* Step 1 is our own button, so only steps 2 and 3 follow the animation. */
.wu-step-2 { animation-name: wu-step-2; }
.wu-step-3 { animation-name: wu-step-3; }

@keyframes wu-step-2 {
  0%, 24% { background-color: #f7f2ff; }
  27%, 100% { background-color: transparent; }
}

@keyframes wu-step-3 {
  0%, 24% { background-color: transparent; }
  27%, 72% { background-color: #f7f2ff; }
  76%, 100% { background-color: transparent; }
}

/* Without motion: the panel stays open on "Delete app". */
@media (prefers-reduced-motion: reduce) {
  .wu-cursor,
  .wu-panel,
  .wu-dialog,
  .wu-ultimo,
  .wu-arrow-bg,
  .wu-del-hover,
  .wu-confirm,
  .wu-ring,
  .wu-step-2,
  .wu-step-3 {
    animation: none;
  }
  .wu-panel {
    transform: none;
  }
  .wu-del-hover,
  .wu-cursor {
    opacity: 1;
  }
  .wu-cursor {
    transform: translate(286px, 160px);
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/WixUninstallGuide.css"],"names":[],"mappings":"AAAA;;2DAE2D;;AAE3D;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;AACd;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,UAAU;AACZ;;AAEA;;;;;;;;;;EAUE,sBAAsB;EACtB,mCAAmC;AACrC;;AAEA;EACE,yBAAyB;EACzB,sCAAsC;EACtC,UAAU;AACZ;;AAEA;EACE,KAAK,2CAA2C,EAAE,UAAU,EAAE;EAC9D,KAAK,2CAA2C,EAAE,UAAU,EAAE;EAC9D,MAAM,0CAA0C,EAAE;EAClD,MAAM,6CAA6C,EAAE;EACrD,MAAM,0CAA0C,EAAE;EAClD,MAAM,0CAA0C,EAAE;EAClD,MAAM,2CAA2C,EAAE;EACnD,MAAM,8CAA8C,EAAE;EACtD,MAAM,2CAA2C,EAAE;EACnD,MAAM,2CAA2C,EAAE;EACnD,MAAM,8CAA8C,EAAE;EACtD,MAAM,2CAA2C,EAAE,UAAU,EAAE;EAC/D,MAAM,2CAA2C,EAAE,UAAU,EAAE;EAC/D,OAAO,2CAA2C,EAAE,UAAU,EAAE;AAClE;;AAEA;EACE,2BAA2B;EAC3B,UAAU;AACZ;;AAEA;EACE,UAAU,UAAU,EAAE;EACtB,WAAW,UAAU,EAAE;EACvB,YAAY,UAAU,EAAE;AAC1B;;AAEA;EACE,wBAAwB;EACxB,mCAAmC;EACnC,4BAA4B;AAC9B;;AAEA;EACE,UAAU,4BAA4B,EAAE;EACxC,WAAW,wBAAwB,EAAE;EACrC,YAAY,4BAA4B,EAAE;AAC5C;;AAEA;EACE,4BAA4B;EAC5B,UAAU;AACZ;;AAEA;EACE,UAAU,UAAU,EAAE;EACtB,WAAW,UAAU,EAAE;EACvB,YAAY,UAAU,EAAE;AAC1B;;AAEA;EACE,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,UAAU,UAAU,EAAE;EACtB,WAAW,UAAU,EAAE;EACvB,YAAY,UAAU,EAAE;AAC1B;;AAEA;EACE,0BAA0B;EAC1B,aAAa;AACf;;AAEA;EACE,UAAU,aAAa,EAAE;EACzB,WAAW,aAAa,EAAE;EAC1B,YAAY,aAAa,EAAE;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,UAAU,UAAU,EAAE;EACtB,WAAW,UAAU,EAAE;EACvB,YAAY,UAAU,EAAE;AAC1B;;AAEA;EACE,UAAU;EACV,eAAe;EACf,eAAe;EACf,UAAU;EACV,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA,aAAa,yBAAyB,EAAE;AACxC,aAAa,yBAAyB,EAAE;AACxC,aAAa,yBAAyB,EAAE;;AAExC;EACE,UAAU,UAAU,EAAE,qBAAqB,EAAE;EAC7C,MAAM,YAAY,EAAE,qBAAqB,EAAE;EAC3C,YAAY,UAAU,EAAE,qBAAqB,EAAE;AACjD;;AAEA;EACE,UAAU,UAAU,EAAE,qBAAqB,EAAE;EAC7C,MAAM,YAAY,EAAE,qBAAqB,EAAE;EAC3C,YAAY,UAAU,EAAE,qBAAqB,EAAE;AACjD;;AAEA;EACE,UAAU,UAAU,EAAE,qBAAqB,EAAE;EAC7C,MAAM,YAAY,EAAE,qBAAqB,EAAE;EAC3C,YAAY,UAAU,EAAE,qBAAqB,EAAE;AACjD;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,oBAAoB;EACpB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,0EAA0E;AAC1E,aAAa,yBAAyB,EAAE;AACxC,aAAa,yBAAyB,EAAE;;AAExC;EACE,UAAU,yBAAyB,EAAE;EACrC,YAAY,6BAA6B,EAAE;AAC7C;;AAEA;EACE,UAAU,6BAA6B,EAAE;EACzC,WAAW,yBAAyB,EAAE;EACtC,YAAY,6BAA6B,EAAE;AAC7C;;AAEA,0DAA0D;AAC1D;EACE;;;;;;;;;;IAUE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;;IAEE,UAAU;EACZ;EACA;IACE,kCAAkC;EACpC;AACF","sourcesContent":["/* One 9 s loop, as on the Manage apps page in Wix: the arrow at the end of our app's row (0-24 %), the panel on the\n   right and its \"Delete app\" (24-47 %), the confirm dialog (47-72 %), then the app row disappears (72-96 %).\n   The step list highlights the step the animation is on. */\n\n.wu-guide-wrap {\n  margin: 0 0 18px 0;\n}\n\n.wu-guide {\n  display: block;\n  width: 100%;\n  height: auto;\n}\n\n.wu-guide text {\n  font-family: inherit;\n}\n\n.wu-title {\n  font-size: 13px;\n  font-weight: 600;\n  fill: #111827;\n}\n\n.wu-name {\n  font-size: 11.5px;\n  font-weight: 600;\n  fill: #111827;\n}\n\n.wu-icon-letter {\n  font-size: 12px;\n  font-weight: 700;\n  fill: #fff;\n}\n\n.wu-del {\n  font-size: 11.5px;\n  font-weight: 500;\n  fill: #111827;\n}\n\n.wu-confirm-label {\n  font-size: 11.5px;\n  font-weight: 600;\n  fill: #fff;\n}\n\n.wu-cursor,\n.wu-panel,\n.wu-dialog,\n.wu-ultimo,\n.wu-arrow-bg,\n.wu-del-hover,\n.wu-confirm,\n.wu-ring,\n.wu-step-2,\n.wu-step-3 {\n  animation-duration: 9s;\n  animation-iteration-count: infinite;\n}\n\n.wu-cursor {\n  animation-name: wu-cursor;\n  animation-timing-function: ease-in-out;\n  opacity: 0;\n}\n\n@keyframes wu-cursor {\n  0% { transform: translate(150px, 172px) scale(1); opacity: 0; }\n  5% { transform: translate(150px, 172px) scale(1); opacity: 1; }\n  19% { transform: translate(353px, 67px) scale(1); }\n  21% { transform: translate(353px, 67px) scale(0.82); }\n  24% { transform: translate(353px, 67px) scale(1); }\n  29% { transform: translate(353px, 67px) scale(1); }\n  40% { transform: translate(286px, 160px) scale(1); }\n  42% { transform: translate(286px, 160px) scale(0.82); }\n  45% { transform: translate(286px, 160px) scale(1); }\n  60% { transform: translate(239px, 122px) scale(1); }\n  62% { transform: translate(239px, 122px) scale(0.82); }\n  65% { transform: translate(239px, 122px) scale(1); opacity: 1; }\n  72% { transform: translate(239px, 122px) scale(1); opacity: 0; }\n  100% { transform: translate(150px, 172px) scale(1); opacity: 0; }\n}\n\n.wu-arrow-bg {\n  animation-name: wu-arrow-bg;\n  opacity: 0;\n}\n\n@keyframes wu-arrow-bg {\n  0%, 15% { opacity: 0; }\n  18%, 26% { opacity: 1; }\n  29%, 100% { opacity: 0; }\n}\n\n.wu-panel {\n  animation-name: wu-panel;\n  animation-timing-function: ease-out;\n  transform: translateX(160px);\n}\n\n@keyframes wu-panel {\n  0%, 22% { transform: translateX(160px); }\n  27%, 70% { transform: translateX(0); }\n  76%, 100% { transform: translateX(160px); }\n}\n\n.wu-del-hover {\n  animation-name: wu-del-hover;\n  opacity: 0;\n}\n\n@keyframes wu-del-hover {\n  0%, 36% { opacity: 0; }\n  38%, 47% { opacity: 1; }\n  50%, 100% { opacity: 0; }\n}\n\n.wu-dialog {\n  animation-name: wu-dialog;\n  opacity: 0;\n}\n\n@keyframes wu-dialog {\n  0%, 46% { opacity: 0; }\n  50%, 68% { opacity: 1; }\n  72%, 100% { opacity: 0; }\n}\n\n.wu-confirm {\n  animation-name: wu-confirm;\n  fill: #dc2626;\n}\n\n@keyframes wu-confirm {\n  0%, 61% { fill: #dc2626; }\n  62%, 66% { fill: #991b1b; }\n  68%, 100% { fill: #dc2626; }\n}\n\n.wu-ultimo {\n  animation-name: wu-ultimo;\n}\n\n@keyframes wu-ultimo {\n  0%, 76% { opacity: 1; }\n  82%, 92% { opacity: 0; }\n  98%, 100% { opacity: 1; }\n}\n\n.wu-ring {\n  fill: none;\n  stroke: #5616ea;\n  stroke-width: 2;\n  opacity: 0;\n  transform-box: fill-box;\n  transform-origin: center;\n}\n\n.wu-ring-1 { animation-name: wu-ring-1; }\n.wu-ring-2 { animation-name: wu-ring-2; }\n.wu-ring-3 { animation-name: wu-ring-3; }\n\n@keyframes wu-ring-1 {\n  0%, 20% { opacity: 0; transform: scale(0.4); }\n  21% { opacity: 0.9; transform: scale(0.4); }\n  29%, 100% { opacity: 0; transform: scale(1.5); }\n}\n\n@keyframes wu-ring-2 {\n  0%, 41% { opacity: 0; transform: scale(0.4); }\n  42% { opacity: 0.9; transform: scale(0.4); }\n  50%, 100% { opacity: 0; transform: scale(1.5); }\n}\n\n@keyframes wu-ring-3 {\n  0%, 61% { opacity: 0; transform: scale(0.4); }\n  62% { opacity: 0.9; transform: scale(0.4); }\n  70%, 100% { opacity: 0; transform: scale(1.5); }\n}\n\n.wu-steps {\n  list-style: none;\n  margin: 12px 0 0 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.wu-step {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  padding: 6px 8px;\n  border-radius: 8px;\n  font-size: 13.5px;\n  line-height: 1.45;\n  color: #374151;\n}\n\n.wu-step-num {\n  flex: 0 0 auto;\n  width: 20px;\n  height: 20px;\n  margin-top: 0.5px;\n  border-radius: 50%;\n  background: #f3eaff;\n  color: #5616ea;\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 20px;\n  text-align: center;\n}\n\n.wu-arrow-chip {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 18px;\n  height: 18px;\n  margin: 0 1px;\n  vertical-align: -4px;\n  border: 1px solid #d1d5db;\n  border-radius: 5px;\n  background: #fff;\n}\n\n.wu-step-num-done {\n  background: #dcfce7;\n  color: #15803d;\n}\n\n/* Step 1 is our own button, so only steps 2 and 3 follow the animation. */\n.wu-step-2 { animation-name: wu-step-2; }\n.wu-step-3 { animation-name: wu-step-3; }\n\n@keyframes wu-step-2 {\n  0%, 24% { background-color: #f7f2ff; }\n  27%, 100% { background-color: transparent; }\n}\n\n@keyframes wu-step-3 {\n  0%, 24% { background-color: transparent; }\n  27%, 72% { background-color: #f7f2ff; }\n  76%, 100% { background-color: transparent; }\n}\n\n/* Without motion: the panel stays open on \"Delete app\". */\n@media (prefers-reduced-motion: reduce) {\n  .wu-cursor,\n  .wu-panel,\n  .wu-dialog,\n  .wu-ultimo,\n  .wu-arrow-bg,\n  .wu-del-hover,\n  .wu-confirm,\n  .wu-ring,\n  .wu-step-2,\n  .wu-step-3 {\n    animation: none;\n  }\n  .wu-panel {\n    transform: none;\n  }\n  .wu-del-hover,\n  .wu-cursor {\n    opacity: 1;\n  }\n  .wu-cursor {\n    transform: translate(286px, 160px);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
